// extracted by mini-css-extract-plugin
export default {"card":"card_card__camC3","white":"card_white__Dfmt3"};